import { gql } from 'urql';

export const SET_MYELF_IN_ACTIVE = gql`
  mutation SetMyselfInactive {
    setMyselfInactive {
      email
    }
  }
`;
